import{jsxs as e,jsx as r}from"react/jsx-runtime";import{useCallback as i}from"react";import{styled as p}from"styled-components";import{TabPanel as t}from"./TabPanel.mjs";import{calcTabHeight as o}from"../services/calcTabHeight.mjs";import{useSize as n}from"../../../../ui/hooks/useSize.mjs";const m=p.div`
  overflow: auto;
`,d=p.div`
  height: 24px;
`,x=p.ul`
  width: 245px;
  padding: 0px 0px 8px 0px;
  margin: 0px;
  list-style-type: none;
  border: 1px solid #e0e0e0;
  border-radius: 1px;
`,s=p.button`
  background: url('images/add_folder_24x24.png') no-repeat scroll left center;
  margin: 0px 2px;
  border: 0px;
  padding: 0px;
  min-width: 30px;
  min-height: 24px;
  cursor: pointer;
`;function a(){const p=i((e=>e(`${o(24)}px`)),[]),a=i((e=>e(`${o(48)}px`)),[]),l=n("98vh",p),h=n("80vh",a);return e(t,{height:l,id:"my-menu-tab",style:{padding:"12px 12px 12px 24px"},children:[r(m,{id:"my-menu1",style:{height:h},children:r(x,{})}),r(d,{id:"my-menu2",children:r(s,{})})]})}export{a as MyMenuTab};
